import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
    CircuitBoard,
    SunMedium,
    Music2,
    ShieldCheck,
    Network,
    Building2,
    ArrowUpRight,
} from "lucide-react";
import SectionLabel from "../SectionLabel";
import { SERVICES } from "../../data/content";

const ICONS = {
    CircuitBoard,
    SunMedium,
    Music2,
    ShieldCheck,
    Network,
    Building2,
};

export default function SignatureServices() {
    return (
        <section
            className="relative section-pad bg-[#0B0B0C] overflow-hidden"
            id="services"
            data-testid="signature-services"
        >
            <div className="shell">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-end mb-16 md:mb-20">
                    <div className="lg:col-span-7">
                        <SectionLabel number="01" label="What We Do" />
                        <h2 className="mt-8 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.08] max-w-2xl">
                            {"Signature services, "}
                            <span className="italic text-[#C9A86A]">
                                quietly engineered.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 lg:pb-3">
                        <p className="text-[#9A958A] text-base md:text-lg leading-[1.85] max-w-md">
                            Six disciplines, composed into one seamless
                            residence. Each authored under the same standard,
                            delivered by the same team, stewarded across the
                            life of the home.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[rgba(201,168,106,0.15)] border border-[rgba(201,168,106,0.15)]">
                    {SERVICES.map((s, idx) => {
                        const Icon = ICONS[s.icon] ?? CircuitBoard;
                        return (
                            <motion.div
                                key={s.slug}
                                suppressHydrationWarning
                                initial={{ opacity: 0, y: 18 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{
                                    duration: 0.7,
                                    delay: idx * 0.05,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                className="bg-[#0B0B0C]"
                            >
                                <Link
                                    to={`/services/${s.slug}`}
                                    className="group relative flex h-full flex-col justify-between gap-10 p-10 md:p-12 transition-colors duration-500 ease-out hover:bg-[#15161A]"
                                    data-testid={`service-card-${s.slug}`}
                                >
                                    <div>
                                        <div className="flex items-center justify-between">
                                            <span className="eyebrow">
                                                {s.number}
                                            </span>
                                            <Icon
                                                size={26}
                                                strokeWidth={1.1}
                                                className="text-[#C9A86A] transition-transform duration-700 ease-out group-hover:scale-110"
                                            />
                                        </div>
                                        <h3 className="mt-10 font-serif text-2xl md:text-3xl text-[#F3EFE7] leading-[1.15] transition-colors duration-500 group-hover:text-[#D9BC80]">
                                            {s.name}
                                        </h3>
                                        <p className="mt-5 text-[#9A958A] text-sm md:text-[15px] leading-[1.85] max-w-xs">
                                            {s.short}
                                        </p>
                                    </div>

                                    <span className="gold-link">
                                        Discover
                                        <ArrowUpRight
                                            size={14}
                                            strokeWidth={1.2}
                                        />
                                    </span>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
